import { createContext, useContext } from 'react';

import useClaimCompanyProductFreeTrialOffer from './hooks/useClaimCompanyProductFreeTrialOffer';

type Context = ReturnType<typeof useClaimCompanyProductFreeTrialOffer>;
const ActivateFreeTrialModalContext = createContext<Context | null>(null);

export const useActivateFreeTrialModalContext = () => {
  const context = useContext(ActivateFreeTrialModalContext);
  if (!context) {
    throw new Error(
      'useActiveFreeTrialModalContext must be used within a ActiveFreeTrialModalProvider'
    );
  }
  return context;
};

export { ActivateFreeTrialModalContext };
